var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "schedule_FILL0_wght300_GRAD0_opsz48 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M31.5038 33.2269L33.1961 31.5346L25.2461 23.5341V13.5231H22.9769V24.4653L31.5038 33.2269ZM24.0033 42.9999C21.3959 42.9999 18.9393 42.5012 16.6335 41.5039C14.3276 40.5066 12.3111 39.1447 10.584 37.4184C8.85687 35.692 7.49442 33.6764 6.49665 31.3716C5.49888 29.0667 5 26.6106 5 24.0033C5 21.3959 5.49867 18.9393 6.496 16.6335C7.49333 14.3276 8.85517 12.3111 10.5815 10.584C12.3079 8.85687 14.3235 7.49442 16.6283 6.49665C18.9332 5.49889 21.3893 5 23.9966 5C26.604 5 29.0606 5.49867 31.3665 6.496C33.6723 7.49334 35.6888 8.85517 37.4159 10.5815C39.143 12.3079 40.5055 14.3235 41.5033 16.6283C42.501 18.9332 42.9999 21.3893 42.9999 23.9966C42.9999 26.604 42.5012 29.0606 41.5039 31.3665C40.5066 33.6723 39.1447 35.6888 37.4184 37.4159C35.692 39.143 33.6764 40.5055 31.3716 41.5033C29.0667 42.501 26.6106 42.9999 24.0033 42.9999ZM24 40.7307C28.6025 40.7307 32.5416 39.0929 35.8173 35.8173C39.0929 32.5416 40.7307 28.6025 40.7307 24C40.7307 19.3974 39.0929 15.4583 35.8173 12.1827C32.5416 8.90702 28.6025 7.2692 24 7.2692C19.3974 7.2692 15.4583 8.90702 12.1827 12.1827C8.90702 15.4583 7.2692 19.3974 7.2692 24C7.2692 28.6025 8.90702 32.5416 12.1827 35.8173C15.4583 39.0929 19.3974 40.7307 24 40.7307Z",
    fill: "#3E4AE7"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNew);
export default __webpack_public_path__ + "static/media/new.0f0dd0ff3076490897ebb599848bd8c8.svg";
export { ForwardRef as ReactComponent };